import { useNavigate } from "react-router-dom";
import { Badge } from "@/components/ui/badge";

const sectors = [
  { id: "ai", name: "AI & Machine Learning", color: "bg-purple-500" },
  { id: "gaming", name: "Gaming & Metaverse", color: "bg-pink-500" },
  { id: "defi", name: "DeFi", color: "bg-blue-500" },
  { id: "layer1", name: "Layer 1", color: "bg-green-500" },
  { id: "layer2", name: "Layer 2", color: "bg-yellow-500" },
  { id: "nft", name: "NFT & Collectibles", color: "bg-red-500" },
  { id: "payments", name: "Payments", color: "bg-indigo-500" },
  { id: "meme", name: "Meme Coins", color: "bg-orange-500" },
  { id: "privacy", name: "Privacy", color: "bg-gray-500" },
  { id: "storage", name: "Storage & Data", color: "bg-teal-500" },
  { id: "rwa", name: "Real World Assets", color: "bg-cyan-500" },
  { id: "exchange", name: "Exchange Tokens", color: "bg-violet-500" },
  { id: "stablecoin", name: "Stablecoins", color: "bg-emerald-500" },
  { id: "infrastructure", name: "Infrastructure", color: "bg-slate-500" },
  { id: "dao", name: "DAO & Governance", color: "bg-rose-500" },
  { id: "oracle", name: "Oracles", color: "bg-amber-500" },
  { id: "interoperability", name: "Interoperability", color: "bg-lime-500" },
  { id: "derivatives", name: "Derivatives", color: "bg-fuchsia-500" },
  { id: "lending", name: "Lending", color: "bg-sky-500" },
  { id: "yield", name: "Yield Farming", color: "bg-green-600" },
];

export function SectorChips() {
  const navigate = useNavigate();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 py-2">
      {sectors.map((sector) => (
        <Badge
          key={sector.id}
          onClick={() => navigate(`/sector/${sector.id}`)}
          className={`${sector.color} hover:opacity-80 cursor-pointer text-white transition-all hover:scale-105 px-4 py-3 text-center justify-center text-sm`}
        >
          {sector.name}
        </Badge>
      ))}
    </div>
  );
}
